<!-- eslint-disable vue/no-v-html -->
<template>
  <div :class="[data.componentBaseClassName, data.componentClassName]">
    <div
      v-if="regionsHtml.title"
      :class="data.titleClassName"
      v-html="regionsHtml.title"
    />
    <div
      v-if="regionsHtml.poster"
      :class="data.posterClassName"
      v-html="regionsHtml.poster"
    />
    <BaseProductSlider
      v-if="sliderProducts"
      :class="data.sliderClassName"
      :products="sliderProducts"
      :tile-context="data.sliderLayout"
      :data-component-type="categoryFeaturedProducts"
    />
  </div>
</template>

<script>
import BaseProductSlider from './BaseProductSlider.vue';
import bemClassesMixin from '../mixins/bemClassesMixin';
import pageDesignerMixin from '../mixins/pageDesignerMixin';
import getFrontConfig from '../../common/getFrontConfig';
import { urlWithSearchParams } from '../../common/utils/url';

const {
  urls: { getProductInfoList },
} = getFrontConfig();
const {
  EXPERIENCE_COMPONENT_TYPES,
} = require('../../../../../config/analytics');

export default {
  name: 'ThePageComponentCategoryFeatured',

  components: {
    BaseProductSlider,
  },

  mixins: [bemClassesMixin, pageDesignerMixin],

  props: {
    category: {
      type: Object,
      default: () => ({
        id: null,
        name: null,
        productIds: null,
      }),
    },
  },

  data() {
    return {
      sliderProducts: null,
      categoryFeaturedProducts:
        EXPERIENCE_COMPONENT_TYPES.categoryFeaturedProducts,
    };
  },

  mounted() {
    this.setProductsInfo();
  },

  methods: {
    setProductsInfo() {
      if (!this.category?.productIds?.length) return;
      fetch(
        urlWithSearchParams(getProductInfoList, {
          ids: this.category?.productIds.join(','),
        })
      )
        .then((res) => res.json())
        .then(({ products = [] }) => {
          this.sliderProducts = products;
        });
    },
  },
};
</script>
